import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";
import { NpsFilters, NpsItem } from "./InsightsNps.d";
import "./InsightsNps.scss";

export const fetchSurveyType = (setSurveysType: Function, setLoading: Function, language: string) => {
  setLoading(true);

  ApiService.get("surveys/types")
    .then((response) => {
      setSurveysType(response.data?.survey_types);
    })
    .catch((error) => {
      console.error("Error fetching survey types:", error);
      alert(translate(language, "PAGES.INSIGHTS.NPS.ERRORS.FETCH_SURVEY_TYPES"));
    })
    .finally(() => setLoading(false));
};

export const fetchSurveyNps = (
  setSurveyNps: Function,
  setLoading: Function,
  filters: NpsFilters = {},
  language: string
) => {
  setLoading(true);

  const params = new URLSearchParams();
  if (filters.language) params.set("language", filters.language);
  if (filters.date_from) params.set("date_from", filters.date_from);
  if (filters.date_to) params.set("date_to", filters.date_to);
  if (filters.survey_type) params.set("survey_type", filters.survey_type);
  if (filters.cohort_id) params.set("cohort_id", filters.cohort_id);

  const query = params.toString();
  const url = query ? `surveys/net-promoter-score?${query}` : `surveys/net-promoter-score`;

  ApiService.get(url)
    .then((response: any) => {
      setSurveyNps(response.data.survey_nps as NpsItem[]);
    })
    .catch((err: any) => {
      console.error("Error fetching NPS survey:", err);
      alert(translate(language, "PAGES.INSIGHTS.NPS.ERRORS.FETCHING_NPS"));
    })
    .finally(() => {
      setLoading(false);
    });
};

export const SEGMENT_COLORS = {
  promoters: "var(--color-green)",
  passives: "var(--color-yellow)",
  detractors: "var(--color-red)",
};

export const chartDataFromNps = (question: NpsItem, language: string, SEGMENT_COLORS: any) => {
  const total = Math.max(question.total_responses, 1);
  return [
    {
      key: translate(language, "PAGES.INSIGHTS.NPS.SEGMENT.PROMOTERS"),
      count: question.promoters_list.length,
      percent: Number(((question.promoters_list.length / total) * 100).toFixed(2)),
      color: SEGMENT_COLORS.promoters,
    },
    {
      key: translate(language, "PAGES.INSIGHTS.NPS.SEGMENT.PASSIVES"),
      count: question.passives_list.length,
      percent: Number(((question.passives_list.length / total) * 100).toFixed(2)),
      color: SEGMENT_COLORS.passives,
    },
    {
      key: translate(language, "PAGES.INSIGHTS.NPS.SEGMENT.DETRACTORS"),
      count: question.detractors_list.length,
      percent: Number(((question.detractors_list.length / total) * 100).toFixed(2)),
      color: SEGMENT_COLORS.detractors,
    },
  ];
};

export const getPercentage = (count: number, total: number) =>
  total > 0 ? ((count / total) * 100).toFixed(2) : "0.00";

export const formatNps = (number: number) => Number(number).toFixed(2);

export const getNpsBadgeVariant = (nps: number) => {
  if (nps >= 30) return "success";
  if (nps >= 0) return "warning";
  return "danger";
};
